import type { SolicitacaoPagamentoDto } from "@/services/solicitacaoPagamento";
import { pixTipoChaveLabel } from "./pagamentoMetodoUtils";

export function renderDadosPagamentoRows(item: SolicitacaoPagamentoDto): Array<{ label: string; value: string }> {
  if (item.formaPagamento === "BOLETO" && item.boletoCodigoBarras) {
    return [{ label: "Código de barras", value: item.boletoCodigoBarras }];
  }
  if (item.formaPagamento === "PIX") {
    const rows: Array<{ label: string; value: string }> = [];
    if (item.pixTipoChave) rows.push({ label: "Tipo chave", value: pixTipoChaveLabel(item.pixTipoChave) });
    if (item.pixChave) rows.push({ label: "Chave Pix", value: item.pixChave });
    if (item.pixContaEmNome) rows.push({ label: "Conta em nome", value: item.pixContaEmNome });
    return rows;
  }
  if (item.formaPagamento === "TRANSFERENCIA") {
    const rows: Array<{ label: string; value: string }> = [];
    if (item.transferenciaTitular) rows.push({ label: "Titular", value: item.transferenciaTitular });
    if (item.transferenciaBanco) rows.push({ label: "Banco", value: item.transferenciaBanco });
    if (item.transferenciaAgencia) rows.push({ label: "Agência", value: item.transferenciaAgencia });
    if (item.transferenciaConta) rows.push({ label: "Conta", value: item.transferenciaConta });
    return rows;
  }
  return [];
}
